import { DataFieldType } from "src/types/data-field.types";
import { createNodeDef } from "../nodes.helpers";

export const numberNodeDef = createNodeDef({
  type: "staticNumber",
  displayName: "Number (static)",
  shortDisplayName: "Number",
  fields: [{ type: DataFieldType.NUMBER, key: "value", label: "Value" }],
  initialData: () => ({ value: 42 }),
  generate: ({ node }) => node.data.value,
});
